import FeatureLinkCard from '@/components/FeatureLinkCard';
import { ALL_FEATURES } from '@/data/featureCards';

export default function LandingPage() {
  return (
    <div className="py-6">
      <div className="flex flex-col max-w-screen-lg lg:mx-auto">
        <div className="flex flex-col gap-4 md:flex-row md:flex-wrap">
          {ALL_FEATURES.map((feature) => (
            <div
              key={feature.href}
              className="flex w-full md:flex-1 md:min-w-[calc(50%-0.5rem)] xl:min-w-[calc(33.333%-0.667rem)]"
            >
              <FeatureLinkCard
                href={feature.href}
                title={feature.title}
                description={feature.description}
                cta={feature.cta}
                iconSrc={'iconSrc' in feature ? feature.iconSrc : undefined}
                iconNode={'iconNode' in feature ? feature.iconNode : undefined}
                fillHeight
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
